<section class="{{ subcategory.children.length | itemsCountToColumnsCount }}">
  <h2>{{ subcategory.name }}</h2>
  <ul>
    @for (link of subcategory.children; track link.url) {
      <li>
        <a
          [routerLink]="link.url | addLocale"
          [queryParams]="link.queryParams"
          rel="noreferrer noopener"
          (click)="linkClick.emit()"
        >
          {{ link.label }}
        </a>
      </li>
    }
  </ul>
</section>
